import { IDonHangCreateRequest } from "../../../model/request/ban-hang/IDonHangCreateRequest";
import { IDonHangDoiTraRequest } from "../../../model/request/ban-hang/IDonHangDoiTraRequest";
import { IDonHangViewModel } from "../../../model/respone/don-hang/IDonHangViewModel";
import { IDonHangViewDetailResponse } from "../../../model/respone/don-hang/IDonHangViewDetailResponse";
import { IBanHangTabReducer } from "../../reducer-model/ban-hang/IBanHangReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IBanHangActionPayload<T> {
    tabId: string,
    data: T
}

export const eBanHangActionsDefine = {
    ADD_NEW_TAB: undefined,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as IBanHangTabReducer,
    CHANGEG_SELECTED_TAB: "",
    CHANGE_ROW_SELECTED_ID: 0,
    CHANGE_SELECTED_ID: 0,
    CHANGE_SHOW_HISTORY: {} as boolean,
    CHANGE_SHOW_PRINT: {} as boolean,
    CHANGE_SHOW_HUY_DON_HANG: {} as boolean,
    CHANGE_SHOW_DOI_TRA_DON_HANG: {} as boolean,
    CHANGE_SHOW_CAP_NHAT_DA_GIAO_HANG: {} as boolean,
    CHANGE_LY_DO_HUY_DON_HANG: {} as string,
    SET_HOC_SINH_LIST: {} as { data: any[], dm_coso_id: number, nam_hoc: string },

    CREATE_DONHANG_START: {} as IBanHangActionPayload<IDonHangCreateRequest>,
    CREATE_DONHANG_SUCCCESS: {} as IBanHangActionPayload<number>,
    CREATE_DONHANG_ERROR: {} as IBanHangActionPayload<string>,

    LOAD_DON_HANG_START: {} as IBanHangActionPayload<number>,
    LOAD_DON_HANG_SUCCESS: {} as IBanHangActionPayload<IDonHangViewModel[]>,
    LOAD_DON_HANG_ERROR: {} as IBanHangActionPayload<string>,

    GET_DETAIL_VIEW_START: {} as IBanHangActionPayload<number>,
    GET_DETAIL_VIEW_SUCCESS: {} as IBanHangActionPayload<IDonHangViewDetailResponse>,
    GET_DETAIL_VIEW_ERROR: {} as IBanHangActionPayload<string>,

    HUY_DON_HANG_START: {} as IBanHangActionPayload<{ id: number, ly_do_huy: string }>,
    HUY_DON_HANG_SUCCCESS: {} as IBanHangActionPayload<number>,
    HUY_DON_HANG_ERROR: {} as IBanHangActionPayload<string>,
    DOI_TRA_DON_HANG_START: {} as IBanHangActionPayload<IDonHangDoiTraRequest>,
    DOI_TRA_DON_HANG_SUCCCESS: {} as IBanHangActionPayload<number>,
    DOI_TRA_DON_HANG_ERROR: {} as IBanHangActionPayload<string>,

    CAP_NHAT_DA_GIAO_HANG_START: {} as IBanHangActionPayload<{ id: number }>,
    CAP_NHAT_DA_GIAO_HANG_SUCCCESS: {} as IBanHangActionPayload<number>,
    CAP_NHAT_DA_GIAO_HANG_ERROR: {} as IBanHangActionPayload<string>,

    SHOW_ORDER_STEPS_MODAL: {} as boolean,

};
export const eBanHangActionIds = generateActionTypeIds(eBanHangActionsDefine, "BAN_HANG");
export type IBanHangActionTypes = IGenericActionType<typeof eBanHangActionsDefine, "BAN_HANG">;
